import * as React from "react"
import { Box, Button, Typography } from "@mui/material"
import { IconSeeker } from "@ui-seeker/core"

import { createSkuDrawer, selectedRows, tableData } from "../@signals"


export default function SkuCandidatesTableToolbar({ selectedData, setSelectedRows }) {
    const selectedCount = selectedRows.value?.length || 0

    const handleCreateSku = () => {
        if (selectedCount === 0) return

        // Get the first selected row to pre-fill some SKU data
        const firstSelected = selectedRows.value[0]

        createSkuDrawer.value = {
            candidates: selectedRows.value,
            prefill: {
                id_brand: firstSelected?.raw?.id_brand,
                brand_name: firstSelected?.raw?.brand
            }
        }
    }

    const handleClearSelection = () => {
        setSelectedRows([])
        selectedRows.value = []
    }

    // Get unique sites and brands from selection
    const uniqueSites = [...new Set(selectedRows.value.map(r => r.raw?.site).filter(Boolean))]
    const uniqueBrands = [...new Set(selectedRows.value.map(r => r.raw?.brand).filter(Boolean))]

    return (
        <Box sx={{
            display: 'flex',
            alignItems: 'center',
            gap: 2,
            px: 2,
            py: 1
        }}>
            <Box sx={{ flex: 1 }}>
                <Typography variant="body2" sx={{ fontWeight: 600 }}>
                    {selectedCount} product{selectedCount !== 1 ? 's' : ''} selected
                </Typography>
                {uniqueSites.length > 0 && (
                    <Typography variant="caption" color="text.secondary">
                        Sites: {uniqueSites.join(', ')} | Brands: {uniqueBrands.join(', ')}
                    </Typography>
                )}
            </Box>

            <Button
                variant="outlined"
                size="small"
                onClick={handleClearSelection}
            >
                Clear
            </Button>

            <Button
                variant="contained"
                size="small"
                color="success"
                startIcon={<IconSeeker icon="plus" />}
                onClick={handleCreateSku}
                disabled={selectedCount === 0}
            >
                Create SKU from Selection
            </Button>
        </Box>
    )
}
